export const providerPrice = products => products?.map(({ total }) => total)?.reduce((a, b) => a + b, 0)

export const getTotalOfValidProducts = products =>
  products?.reduce((acc, { amount }) => (amount > 0 ? acc + 1 : acc), 0)
